import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext, useState } from 'react';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import { useFacetData } from '~/context/common/FacetDataContext';
import FilterDrawer from './FilterDrawer';
import { Label } from './FiltersMenu.styles';
import useRangeUpdater from './hooks/useRangeUpdater';
import InputRangeSlider from './InputRangeSlider';

export default function MPG() {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const facetData = useFacetData();
  const [rangeValues, setRangeValues] = useState([
    appliedFilters.mpg?.min ?? facetData.mpg?.min ?? 0,
    appliedFilters.mpg?.max ?? facetData.mpg?.max ?? 0
  ]);

  const onUpdate = useRangeUpdater({
    filterKey: 'mpg',
    max: facetData.mpg?.max,
    min: facetData.mpg?.min
  });

  useSubsequentEffect(() => {
    setRangeValues([
      appliedFilters.mpg?.min ?? facetData.mpg?.min ?? 0,
      appliedFilters.mpg?.max ?? facetData.mpg?.max ?? 0
    ]);
  }, [
    appliedFilters.mpg?.max,
    appliedFilters.mpg?.min,
    facetData.mpg?.max,
    facetData.mpg?.min
  ]);

  return (
    <FilterDrawer
      testId="facet-mpg"
      facetContent={facetData.mpg}
      facetName="MPG"
    >
      <Label>MPG/MPGe</Label>
      <InputRangeSlider
        data-analytics-id="adjust-mpg-range"
        idPrefix="mpg"
        min={facetData.mpg?.min}
        max={facetData.mpg?.max}
        thumbBehavior="slide-through"
        value={rangeValues}
        onValueChange={setRangeValues}
        onValueCommit={onUpdate}
      />
    </FilterDrawer>
  );
}
